import { useRouter } from 'next/router';
import React, { useCallback, FC } from 'react';
import BooksStep, {
  StepItems,
} from '../../../molecules/merchant/resources/book/BooksStep/';
import { useShallowEqualSelector } from '../../../hooks/redux';
import { goTo } from '../../../redux/actions/merchants/resources/books';
import { ReduxState } from '../../../redux/reducers';
import { useAppDispatch } from '../../../redux';
import { buildSiteUrl } from 'src/utils/request-url';

type Props = {
  allSteps: StepItems[];
  current: number;
  resourcePublicId: string;
};
export const BooksStepOrganism: FC<Props> = ({
  allSteps,
  current,
  resourcePublicId,
}) => {
  const dispatch = useAppDispatch();
  const step = useShallowEqualSelector((state: ReduxState) => {
    return state.merchantsResourcesBooks.step;
  });
  const router = useRouter();

  const handleBack = useCallback(() => {
    if (step === 1) {
      router.push(buildSiteUrl(`/${resourcePublicId}`, 'next'));
    }
    if (step && step >= 2) {
      dispatch(goTo(step - 1));
    }
  }, [router, resourcePublicId, step, dispatch]);

  return (
    <BooksStep
      allSteps={allSteps}
      current={current}
      onRequestBack={handleBack}
    />
  );
};
